module.exports = {
  config: {
    h5tgadoc: "/en/cp/guide/api.html"
  },
  router: {
    index: "Home",
    GameManagement: "Game Management",
    operation: "Statistics",
    adincome: "Ads Revenue",
    income: "Ads Report",
    adorder: "Order Management",
    adresult: "Payments",
    overview: "Data Overview",
    retained: "Retention Analysis",
    game_analyse: "Game Analysis",
    AccountManagement: "Developer Account",
    Info: "Account details",
    identity: "Identity Authentication",
    ChangePassword: "Reset Password",
    DeveloperDocument: "Developer Document",
    contact: "Contact us",
    GameDetails: "Game",
    GameInfo: "Game Project",
    GameMaterial: "Game Material",
    login: "Login",
    register: "Sign up",
    ForgetPassword: "Forgot Password?",
    agreement: "User Agreement",
    rank: "Leaderboard Settings",
    basicSettings: "General Settings",
    pay: "Payment Settings",
    share: "Sharing Settings",
    ad: "Ad Settings",
    Exploit_settings: "Dev Settings",
    type: "Account Type",
    appManagement: "App Management",
    appMaterial: "App Material"
  },
  index: {
    banner: {
      title: "TGA DEV PLATFORM",
      content1:
        "Partner with top tier channels worldwide, reaching and monetizing",
      content2: "your games with millions of users."
    },
    fanctions: {
      name: "FUNCTIONS",
      title: "Connect Game Developers To The Global Market",
      content:
        "TGA integrates global partner resources, monetizing game content with more impressions, traffic, revenue, and gives you access to a broader market space with more diversified business models."
    },
    advantages: {
      name: "ADVANTAGES",
      title: "Quick Monetization",
      content1:
        "Diversified channel resources to reach billions of users worldwide.",
      content2:
        "Comprehensive data analysis capabilities with one-stop settlement services. "
    },
    sdk: {
      name: "Easy SDK integration",
      advertising: {
        content1: "Reward-based",
        content2: "Advertising"
      },
      leaderboard: {
        content1: "Leaderboard ",
        content2: "Challenging Gameplay"
      },
      singlen: {
        content1: "Single-Sign-on",
        content2: "Always Connected"
      },
      button: "Explore More"
    },
    global: {
      name: "Global Partners",
      title: "Exclusive Game Titles",
      content1: "Leading Industry Partners"
    },
    join: {
      title1: "JOIN US",
      button: "Get In Touch"
    }
  },
  contact: {
    about: {
      title: "ABOUT TGA",
      content:
        "Games are our Passion.We are looking for talented individuals that are highly passionate with the gaming industry and are willing to grow together with us."
    },
    careers: {
      name: "CAREERS",
      title1: "Dev.&Operation",
      title2: "Channel Building",
      title3: "Business Development",
      title4: "Platform Construction",
      title5: "Game",
      text1: [
        "Over 10 years experiences in the filed",
        "Have successful case covered PC, Mobile and Platform",
        "Owned several stable mobile games and H5 production studio and over 10,000 close partner",
        "Owned self-developed AI to do personalized recommendation within over 400,000 personas"
      ],
      text2: [
        "Original 91 Product team with 10 years experiences of coordination",
        "13 years oversea gaming platform operation",
        "10 years experiences in mideast region",
        "Over 200M users platform operation"
      ],
      text3: [
        "10 years in gaming industry",
        "The leader of mobile gaming development in China",
        "Considered to be an incubator for hundreds of listed company in China",
        "Direct contact to Chairman level in 80% of gaming company in China"
      ],
      text4: [
        "MMOsite.com (2005-2009), Used to the be top 3 MMORPG Portal worldwide, sold to ND in 2008",
        "91 Mobile 200M active user with 150M daily transaction and sold to Baidu for 1.9B$ cash",
        "Mobomarket, Macrobile，100M Oversea Users with 50% of weekly active",
        "Wakit, Mideast gaming platform，22m active users aquired",
        "Bazik, Iran gaming with 6m users, covered 3/4 Iran mobile users",
        "Get5, 1M Indo users，sold to telkomsel",
        "VR platform operation and design",
        "IM Product design and integratio"
      ],
      text5: [
        "Built the products covered MMORP, SLG, ARPG, MOBA category",
        "RPG with 3M DAU，8M$ monthly turnover",
        "APRG with 5M DAU, with 10M$ monthly turnover",
        "MOBA Games with450K DAU in PC, 1M DAU in Mobile, and 10M Monthly turnover"
      ]
    },
    contact: {
      name: "CONTACT US",
      company: "JUST4FUN PTE.LTD. ",
      place: "2 Havelock Road #06-01 Havelock2 Singapore 059763",
      email: "business_global@just4fun.sg",
      form: {
        first: "First Name",
        last: "Last Name",
        email: "Email Address",
        company: "Company Name",
        remark: "Remark",
        submit: "Submit"
      },
      info: "Please fill in the informatio",
      emailInfo: "Please enter the correct email address",
      success: "Submit Success",
      error: "Submit Error"
    }
  },
  login: {
    to_login: "Account Login",
    login: "Log in",
    no_id: "No Account？",
    to_register: "Sign up",
    no_psd: "Forgot Password?",
    email: "Email",
    email_error: "Email Format is incorrect",
    psd: "Password",
    empty_psd: "Password is required",
    sum_length: "Letters, numbers or English symbols, 8-15 digits",
    empty_email: "Email is required"
  },
  register: {
    registeraccount: "Sign up",
    getcode: "Get verification code",
    registertext: "Sign up",
    emailsite: "Email",
    email_error: "Email Format is incorrect",
    text: "please input an unregistered Email",
    code: "Code",
    codekong: "Code is required",
    codetext:
      "Please input 6-digit verification code from the activated mailbox",
    psd: "Password",
    empty_psd: "Password is required",
    psd_init: "Letters, numbers or English symbols, 8-15 digits,case sensitive",
    psd1: "Confirm password",
    no_psd1: "Inconsistent password",
    emailkong: "Email is required",
    code_error: "Code format is incorrect",
    anewgetcode: "Resend",
    codesuccess: "Acquired successfully"
  },
  account_type: {
    totype: "Select account type",
    game: "Game Developer",
    cptext: "I got the game resource, I want to join the TGA developer",
    app: "Channel Partner",
    apptext: "I'd like to monetize the traffic of my channel resources",
    confirm: "Confirm"
  },
  agreement: {
    tgaagreement: "TGA Development Platform Agreement",
    agreementtext:
      "鉴于您作为个人，为其开发之系列游戏软件的著作权人或者合法授权人，以下简称甲方；福州酷乐文化传媒有限公司是一家游戏平台商，以下简称乙方，通过原创游戏平台以展示甲方之游戏；甲方可在乙方的原创游戏平台免费发布游戏，甲方提供推广乙方平台的服务，双方对上述合作事宜，根据《中华人民共和国合同法》、《中华人民共和国著作权法》、《计算机软件保护条例》等相关法律法规之规定，当甲方点击页面的同意（若您未满18周岁，请在监护人的同意下进行本操作）即表示甲方与乙方签订本合作协议。特别提示：若您曾与福州酷乐文化传媒有限公司因游戏推广合作签订过任何协议如原创游戏广告分成合作协议，自本协议生效后，原先签订的协议自动终止，本协议生效以前所有未结算的款项，均以本合作协议约定的为准。本合作协议只适用于您作为个人的情形，若您为公司或其他组织，需与乙方签订纸质版的相关合作协议。具体条款如下：",
    agreeagreement: "Agree and accept the agreement ",
    next: "Next",
    nonext: "Please accept the agreement",
    error: "Server is busy"
  },
  footer: {
    text: "Copyright © 2019-2021 JUST4FUN PTE.LTD. All Rights Reserved.",
    to_login: "Please login",
    to_info: "Please complete registration first"
  },
  forget: {
    no_psd: "Forgot password?",
    next: "Next",
    emailsite: "Email",
    getcode: "Get verification code",
    last: "Previous",
    confirm: "Confirm",
    email_error: "Email Format is incorrect",
    getemail: "please input the email to retrieve password",
    code: "Code",
    no_code: "Code is required",
    psd: "Password",
    emptypsd: "Password is required",
    psd1: "Confirm Password",
    nopsd1: "Inconsistent password",
    regain: "Resend",
    getsuccess: "Acquired successfully",
    code_error: "Failed to acquire code",
    code_error2: "Code request too frequently",
    code_error3: "Code request has reached today's limit",
    successfully: "modify successfully"
  },
  account_management: {
    Change_Password: {
      ChangePassword: "Reset Password",
      alter: "Change",
      originalpsd: "Old Password",
      please_originalpsd: "Please input the old password",
      psd: "Password",
      empty_psd: "Password is required",
      psd_init:
        "Letters, numbers or English symbols, 8-15 digits,case sensitive",
      psd1: "Confirm Password",
      no_psd1: "Inconsistent password",
      empty_originalpsd: "Old Password is required",
      successfully: "modify successfully"
    },
    authentication: {
      text:
        "You have not submitted the identity authentication review, and the game review cannot proceed.",
      text1:
        "You have submitted the identity authentication review, please be patient for the review process.",
      text2: "You have passed the identity authentication review.",
      text3: "You failed to pass the identity authentication review. ",
      developer: "Developer",
      progress: "ID authentication progress",
      type: "Developer type",
      individual_person: "Individual",
      company: "Corporate",
      email:
        "If you need to modify the item, please contact custom service email",
      copy: "Click to copy",
      account: "Beneficiary",
      please_account: "Please input the name of beneficiary",
      account_kong: "Beneficiary is required",
      id: "ID card No.",
      please_id: "Please input ID card No.",
      id_kong: "ID card No. is required",
      idNo: "Registration No.",
      please_idNo: "please input Uniform Social Credit Code",
      idNo_kong: "Uniform Social Credit Code is required",
      idtext: "Front and back of ID card",
      idNotext: "Scanned copy of business license",
      sample: "Example",
      uploadid: "Please upload front and back of ID card",
      uploadidNo: "Please upload scanned copy of business license",
      uploadidtext:
        "Please upload JPG file, no more than 2M,and combine front and back of ID card in one image to upload",
      uploadidNotext: "Please upload JPG file, no more than 2M",
      country: "Country",
      please_country: "Select",
      bank: "Bank Name",
      select: "Select",
      please_bank: "Please select the bank ",
      province: "Bank branch location",
      please_province: "Please select bank branch province and city",
      bankName: "Bank Name",
      please_bankName: "Please input bank name",
      bankName_kong: "Bank Name is required",
      bankAccount: "Bank Account",
      please_bankAccount: "Please input bank account",
      groupType: "Invoice type",
      please_groupType: "Please input invoice type",
      send_review: "Submit ",
      audit: "In review",
      isaudit: "Confirm to submit",
      ok: "Confirm",
      cancel: "Cancel",
      sendsuccess: "Submit successfully",
      upimgerror: "JPG supported only!",
      upimgerror2: "The avatar image can not exceed 2MB!",
      upsuccess: "Uploaded successfully ",
      uperror: " Upload failed",
      copysuccess: "Copy success",
      uploadimg: require("@/img/img_en.png"),
      code: "Swift Code is required.",
      code_please: "Please input Swift Code.",
      bank_site: "Bank Address",
      bank_kong: "Bank Address is required",
      address: "Please input bank address",
      currency_type: "Currency Type",
      type_kong: "Currency Type is required.",
      swift_code: "Swift Code"
    },
    information: {
      developer: "Developer",
      progress: "ID authentication progress",
      type: "Developer type",
      individual_person: "Individual",
      company: "Corporate",
      email:
        "If you need to modify the item, please contact custom service email",
      copy: "Click to copy",
      name: "First Name",
      surname: "Last Name",
      empty_name: "Last Name is required",
      enterprise: "Corporate name",
      empty_enterprise: "Please input corporate name",
      location: "Location",
      select: "Select",
      select_location: "Select location",
      site: "Contact address",
      select_site: "Please input your address",
      phone: "Phone number",
      alter: "Modify",
      select_phone: "Please input phone number",
      save: "Save",
      save_success: "Saved succesfully",
      copysuccess: "Copy success"
    }
  },
  info: {
    basicinfo: "Account details",
    type: "Developer type",
    individual_person: "Individual",
    company: "Corporate",
    name: "First Name",
    surname: "Last Name",
    empty_name: "Last Name is required",
    enterprise: "Corporate Name",
    empty_enterprise: "Please input corporate name",
    location: "Location",
    select: "Select",
    select_location: "Select location",
    site: "Contact address",
    select_site: "Please input your address",
    phone: "Phone number",
    select_phone: "Please input phone number",
    empty_phone: "Phone number is required",
    next: "Next",
    error: "Server is busy"
  },
  layout: {
    select_login: "Please login",
    select_info: "Please complete registration first",
    logo: require("@/img/logo_en.png"),
    logo2: require("@/img/logo_en2.png")
  },
  nav_user: {
    login: "Login",
    register: "Sign up",
    logout: "Logout",
    languagezh: "简体中文",
    languageen: "English",
    langtext: "English"
  },
  operational_data: {
    app: "APP",
    game: "game",
    select: "Select",
    select_name: "Please input order No.",
    select_id: "Please input game ID",
    order: "Order No.",
    userId: "User ID",
    data: "Export Data",
    selecttime: "Date range",
    orderstate: "Order Status",
    send: "Query",
    no_result: "No Data",
    orderstatus: [
      "All",
      "Processing",
      "Payment successfully",
      "Payment Failure"
    ],
    createTime: "Date",
    wareName: "Item",
    wareCnt: "Quantities",
    price: "Amount",
    user: "User",
    state: "Transaction Status",
    pay1: "Processing",
    pay2: "Payment successfully",
    pay3: "Payment Failure",
    kong: "null",
    income: {
      day: "Date",
      income: "Revenue",
      incomeCount: "Total revenue",
      estimatedRevenue: "Estimated Income",
      estimatedRevenueCount: "Total estimated income",
      oneMonths: "Last Month",
      threeMonths: "Last 3 Months",
      sixMonths: "Last 6 Months",
      tip: "Note:",
      tipFirst:
        "1. The estimated income does not deduct bank charges and related taxes, which varies from month to month.",
      tipSecond: "2. The estimated income serves as reference purpose only.",
      tipThird:
        "3. This month income will be settled around 20th of next month. Please contact the platform business personnel for the process."
    },
    overview: {
      app: "APP",
      select: "Select",
      platform: "Platform",
      dateRange: "Date Range ",
      Apply: "Apply",
      dataOverview: "Data Overview",
      cumulativeUsersTitle: "Cumulative Users",
      yesterdayDAU: "Yesterday DAU",
      yesternewUsers: "Yesterday New Users",
      yestergameUsers: "Yesterday Game Users",
      yestergameTimes: "Yesterday Game Launch Times",
      activeTrend: "Active Trend ",
      cumulativeUsers: "Cumulative Users",
      DAU: "DAU",
      newUsers: "New Users",
      gameUsers: "Game Users",
      gameTimes: "Average Game Launch Times",
      exportData: "Export Data",
      date: "Date",
      newUsersRate: "New Users Rate",
      averageGameLaunchTimes: "Average Game Launch Times"
    },
    retained: {
      app: "APP",
      select: "Select",
      platform: "Platform",
      dateRange: "Date Range ",
      Apply: "Apply",
      retentionAnalysis: "Retention Analysis",
      newUsersRetention: "New Users Retention",
      retainedUsersRetention: "Retained Users Retention",
      day: "Day",
      week: "Week",
      exportData: "Export Data",
      date: "Date",
      users: "Users",
      day2Users: "Day 2 Users",
      day2retentionRate: "Day 2 RetentionRate",
      day3Users: "Day 3 Users",
      day3retentionRate: "Day 3 RetentionRate",
      day7Users: "Day 7 Users",
      day7retentionRate: "Day 7 RetentionRate",
      day15Users: "Day 15 Users",
      day15retentionRate: "Day 15 RetentionRate",
      day30Users: "Day 30 Users",
      day30retentionRate: "Day 30 RetentionRate",
      startDate: "Start Date",
      endDate: "End Date",
      week2Users: "Week 2 Users",
      week2RetentionRate: "Week 2 Retention Rate",
      week3Users: "Week 3 Users",
      week3RetentionRate: "Week 3 Retention Rate",
      week4Users: "Week 4 Users",
      week4RetentionRate: "Week 4 Retention Rate"
    },
    game_analyse: {
      app: "APP",
      select: "Select",
      platform: "Platform",
      gameName: "Game Name",
      dateRange: "Date Range ",
      Apply: "Apply",
      gameAnalysis: "Game Analysis",
      gameUsers: "Game Users",
      averageGameLaunchTimes: "Average Game Launch Times",
      exportData: "Export Data",
      date: "Date",
      gameLaunchTimes: "Game Launch Times"
    }
  },

  gamelist: {
    state: "Review status",
    addgame: "Create Game",
    addApp: "Create App",
    gamename: "Please input the game name",
    appname: "Please enter the App name",
    began: "Start to",
    create: "Create",
    creategame: "Your first game!",
    createapp: "Your first app!",
    admi: "Management",
    down: "Remove",
    up: "Upload",
    arrSelect: [
      "App status",
      "unsubmitted",
      "In review",
      "Review successfully",
      "Review Failed",
      "Published"
    ],
    appId: "App ID",
    gameId: "Game ID",
    appnames: "App name",
    appName: "Game name",
    version: "Online version",
    checkState: "Review status",
    kong: "null",
    allstate: [
      "unsubmitted",
      "In review",
      "Review successfully",
      "Review failed",
      "Published"
    ],
    lastModified: "Update time",
    btn: "Manage",
    upSuccess: "Upload successfully",
    downSuccess: "Remove successfully",
    isup: "Confirm to upload?",
    isdown: "Confirm to remove?",
    ok: "Confirm",
    cancel: "Cancel"
  },

  foundgame: {
    creategame: "Create game",
    complete: "Game details",
    send: "Submit ",
    publish: "Publish",
    info: "Game details",
    gameType: " Game Type",
    aloneGame: "Indie Game",
    battleGame: "PVP Game",
    battleSum: "PVP Option",
    radio: "Screen orientation",
    across: "Landscape",
    vertical: "Portrait",
    lang: "Language",
    langkong: "Language is required",
    gamename: "Game name",
    gameinfo: "Introduction",
    agreement: "I've accepted and agreed",
    agreement1: "TGA Developer Agreement",
    english: "English",
    chinese: "Chinese",
    Turkey: "Turkey",
    tag: {
      title: "Game Tags",
      add: "Add",
      tip:
        "Used for game title search and recommendation. Once launched online, it cannot be modified.",
      confirm: "Confirm"
    }
  },
  foundapp: {
    tip: "Remark:",
    tipFirst: "Place the formal package name in the first position",
    createapp: "Create App",
    complete: "App details",
    send: "Submit ",
    info: "App details",
    apptype: "App type",
    android: "Android",
    ios: "IOS",
    web: "WEB",
    allApp: "Both",
    // androidtext: "Android version supported only currently",
    androidtext: "Please separate multiple package names with commas",
    lang: "Language",
    langkong: "Language is required",
    gametype: "Acceptable game types",
    across: "Landscape",
    vertical: "Portrait",
    all: "Both",
    agreement: "I've accepted and agreed",
    agreement1: "TGA Developer Agreement",
    english: "English",
    chinese: "Chinese",
    Turkey: "Turkey",
    appname: "App name",
    packageName: "Package name"
  },

  appinfo: {
    createapp: "Create App",
    complete: "App details",
    send: "Submit ",
    createtime: "Last updated",
    appstate: "Status",
    state: [
      "Developing",
      "In review",
      "Review successfully",
      "Review failed",
      "Developing",
      "Published"
    ],
    share: {
      on: "On",
      off: "Off",
      sharing: "Third-party Sharing",
      appID: "App ID",
      sharesetting: "Sharing Settings"
    },
    ad: {
      on: "On",
      off: "Off",
      ads: "Third-party Ads",
      appID: "App ID",
      adsetting: "Ad Settings"
    },

    pay: {
      paysetting: "Payment settings",
      paytoken: "Payment key",
      copy: "Click to copy",
      dataTokeninfo: "The key is sensitive, please don't disclose it.",
      url: "Callback address",
      save: "Save",
      urlkong: "Callback address is required",
      save_success: "Save successfully",
      copysuccess: "Copy successfully"
    },

    exploit: {
      setting: "General settings",
      sdk: "SDKAppID",
      status: "Status",
      datatoken: "Key",
      copy: "Click to copy",
      dataTokeninfo: "The key  is the secret, please don't disclose it.",
      sdkinfo: "SDK",
      text: "Click to review",
      text1: "SDK Guide",
      email: "If you are any problems, please contact custom service Email.",
      state: [
        "Developing",
        "In review",
        "Review successfully",
        "Review failed",
        "Developing",
        "Published"
      ],
      copysuccess: "Copy successfully"
    },

    basic: {
      basicinfo: "App details",
      apptype: "App type",
      android: "Android",
      // androidtext: "Android version supported only currently",
      androidtext: "Please separate multiple package names with commas",
      lang: "Language",
      langkong: "Language is required",
      gametype: "Acceptable game types",
      across: "Landscape",
      vertical: "Portrait",
      all: "Both",
      appname: "App name",
      send: "Submit",
      english: "English",
      chinese: "Chinese",
      success: "Submit successfully",
      error: "Failed to submit",
      packageName: "Package name"
    },

    material: {
      app_material: "Required materials",
      logo: "Logo",
      format: "JGP,JPEG,GIF,PNG supported only",
      size: "Size：256 x 256",
      size2: "Space: no more than 30K",
      apppackage: "App package",
      apk: "APK supported only",
      time: "Last updated",
      no: "null",
      send_review: "Submit ",
      cancel_review: "Cancel",
      text: "You are required",
      identity: "Pass identity authentication review",
      text2: "To sumbit for review",
      emailtext:
        "You have submitted for review, please wait for the notice from your Email. If you have any questions, please contact customer service Email.",
      copy: "Click to copy",
      cancelsuccess: "Cancel successfully",
      logopackage: "Please upload Logo or App package",
      onthecrossinfo: "Uploading",
      sendsuccess: "Submit successfully",
      onthecrosapk: "APK supported only to upload",
      onthecrossimg: "Picture format supported only to upload Logo",
      onthecrosslogo: "The uploaded Logo can't exceed 30k!",
      copysuccess: "Copy successfully",
      apppackageurl: "apk link",
      appservice:
        "APK download link: Please input correct package download link for sharing page and submission.",
      uploadimg: require("@/img/img_en.png")
    }
  },

  gameinfo: {
    creategame: "Create game",
    complete: "Game details",
    send: "Submit ",
    publish: "Publish",
    createtime: "Last updated",
    gamestate: "Game Status",
    state: [
      "Developing",
      "In review",
      "Review successfully",
      "Review failed",
      "Developing",
      "Published"
    ],
    pay: {
      paysetting: "Payment settings",
      paytoken: "Payment key",
      copy: "Click to copy",
      dataTokeninfo: "The key is sensitive, please don't disclose it.",
      url: "Callback address",
      save: "Save",
      urlkong: "Callback address is required",
      save_success: "Save succesfully",
      copysuccess: "Copy successfully"
    },

    exploit: {
      setting: "General settings",
      sdk: "SDKAppID",
      status: "Status",
      datatoken: "Key",
      copy: "Click to copy",
      dataTokeninfo: "The key is sensitive, please don't disclose it.",
      sdkinfo: "SDK",
      text: "Click to review",
      text1: "SDK Guide",
      email: "If you are any problems, please contact custom service Email.",
      state: [
        "Developing",
        "In review",
        "Review successfully",
        "Review failed",
        "Developing",
        "Published"
      ],
      copysuccess: "Copy successfully"
    },

    basic: {
      gamebasicinfo: "Game details",
      gameType: " Game Type",
      aloneGame: "Indie Game",
      battleGame: "PVP Game",
      battleSum: "PVP Option",
      radio: "Screen orientation",
      across: "Landscape",
      vertical: "Portrait",
      lang: "Language",
      langkong: "Language is required",
      gamename: "Game name",
      gameinfo: "Introduction",
      send: "Submit",
      english: "English",
      chinese: "Chinese",
      Turkey: "Turkey",
      success: "Submit successfully",
      error: "Failed to submit"
    },

    material: {
      tip: "Remark:",
      tipFirst: "1.self-own server, in-game purchase, ads,etc",
      game_material: "Game material",
      gamelogo: "Game Logo",
      format: "JGP,JPEG,GIF,PNG supported only",
      size: "Size：256 x 256",
      size2: "Space: no more than 30K",
      cooperation: "Cooperation Model",
      myservers: "Use developer server",
      platformservers: "Use platform Server",
      indieGame: "Indie game",
      url: "URL address",
      gameurl: "Please input the game link",
      gamemainfile: "Game main file",
      gamepreview: "Game preview",
      onthecross: "Uploading",
      text:
        "Please process HTML5 games into a zip file before uploading. The entry file needs to be renamed as index.html and located in the root directory.",
      text1: "The file format in the zip package is limited to",
      text2:
        "htm,html,js,css,jpg,jpeg,gif,png,mp3,ogg,m4a,xml,csv,dat,atf,json,plist,wav,thm,fnt,exportjson,ttf,tmx,exml,datagz,jsgz,memgz,unityweb,scml,scon,ani,atlas,lani,lh,lmat,lm,sk,ls,lav,wasm,pck,fui,ltc,prefab,part,ltcb,lamat,txt,dbbin。The file name can only use English letters, English brackets, numbers, underscores, and minus signs. Files that do not meet the above conditions will be filtered out.",
      attention: "Note:",
      text3: "1.Ads and external links are not allowed in the game",
      text4:
        "2.The single file is limited to 500M. If your file exceeds 500M, please contact",
      copy: "Click to copy",
      send: "Submit",
      logoinfo: "Please upload logo or main flie",
      onthecrossinfo: "Uploading",
      save_success: "Save succesfully",
      onthecrosszip: "Zip file supported only to upload",
      onthecrossimg: "Picture format supported only to upload Logo",
      onthecrosslogo: "The uploaded Logo can't exceed 30k!",
      copysuccess: "Copy successfully",
      uploadimg: require("@/img/img_en.png"),
      upsuccess: "Uploaded successfully ",
      uperror: " Upload failed"
    },

    game: {
      gameinfo: "Game details",
      experience: "Test version",
      send: "Submission time",
      no_version: "No version",
      gamepreview: "Game preview",
      review_version: "Version for review",
      no_review: "No review",
      send_review: "Submit ",
      cancel_review: "Cancel",
      text: "You are required",
      identity: "Pass identity authentication review",
      game_material: "Submit game materials",
      text2: "To sumbit for review",
      emailtext:
        "The review result will be nofified to you by Email.If you have any questions,please contact",
      copy: "Click to copy",
      online_version: "Published Version",
      publish: "Publish",
      publish_text:
        "You need to pass the review before you can release the game",
      publish_text1: "You've passed the review and can release your game now",
      version: "Version No.",
      ok: "Confirm",
      cancel: "Cancel",
      releasesuccess: "Published successfully",
      sendsuccess: "Submit successfully",
      no_preview: "No preview",
      copysuccess: "Copy successfully"
    },

    rank: {
      rank_title: "leaderboard settings",
      ranklist: "Leaderboard list",
      addrank: "Add leaderboard",
      updateRank: "Update leaderboard",
      no_result: "No data",
      name: "Leaderboard name",
      nameplaceholder: "Please define leaderboard name",
      nametext:
        "Note:The leaderboard name will present to players.Please input english name.",
      sum: "Numerical definition",
      sumtext:
        "Note:Define the numerical name of the list,such as score,level….Please input english name.",
      sumplaceholder: "Please input numerical defintion",
      maxsum: "Maximum score",
      maxsumplaceholder: "Please input the maximum score",
      maxsumtext:
        "Note: Input the maximum score of the leaderboard. If the score is exceeded, it will not be included in the leaderboard.",
      radiotime: "Leaderboard unique ID",
      radioday: "Daily",
      radioweek: "Monthly",
      randiomonth: "Yearly",
      lasting: "Permanent",
      radiotimetext:
        "The leaderboard data will be reset according to refresh interval.",
      radiotimeactive:
        "Note: It cannot be modified after saving. If you input incorrectly, you can delete it and add a new one",
      solt: "Leaderboard sequence",
      soltplaceholder: "Please reset leaderboard sequence",
      solttext:
        "Note:It's the leaderboard display order when there are multiple leaderboards.Input the number,the smaller the number,the higher the ranking",
      soltradio: "Sorting rules",
      soltradiopositive: "From small to large ",
      soltradioreversed: "From large to small ",
      soltradiotext:
        "From large to small: the higher the score,the higher the ranking;From small to large: the lower the score,the higher the ranking",
      soltradioactive:
        "Note: It cannot be modified after saving. If you input incorrectly, you can delete it and add a new one",
      send: "Save",
      rankid: "Leaderboard ID",
      rankName: "Leaderboard name",
      sumname: "Numerical defintion",
      idx: "Leaderboard sequence",
      type: "Refresh interval",
      action: "Manage",
      alter: "Modify",
      deletes: "Delete",
      clearrecord: "Clear Records",
      maxsumerror: "Incorrect maximum score",
      error: "Please fill in completely",
      save_success: "Saved succesfully",
      save_error: "Failed to save",
      edit_success: "Edited successfully",
      edit_error: "Failed to edit",
      system_error: "System error, please try again later",
      eliminate_success: "Cleanup successfully",
      eliminate_error: "Failed to cleanup",
      delete_success: "Deleted successfully",
      delete_error: "Failed to delete",
      ok: "Confirm",
      cancel: "Cancel",
      initmodel: "Confirm to delete the leaderboard?"
    }
  },

  code: {
    info: "Server is busy",
    "-101": "Email format is incorrect",
    "-100": "Registration or login failed",
    "10008": "Account has been registered",
    "-114": "Account is blocked",
    "1001": "Verification code incorrect,expired or invalid",
    "-103": "Password format is incorrect",
    "-104": "Password length is incorrect",
    "-113": "Account password are required",
    "-31": "Failed to send SMS",
    "-36":
      "Verification codes are required too frequently,too close to the last time",
    "-37":
      "Verification codes are required too frequently,too many times in a time period",
    "-111": "The Email hasn't not been registered",
    "-110": "User login failed",
    "10014": "Incorrect password"
  }
};



// WEBPACK FOOTER //
// ./src/assets/common/lang/en.js